import React from "react"
import { Col } from "react-bootstrap"

import CheckBox from "./checkbox"
import InputBox from "./wdn-input-box"

import "./min-max-input.scss"

const MinMaxInput = props => {
  return (
    <>
      <Col className={props.leftColClass}>
        <InputBox
          label={props.label}
          type={props.minType}
          name={props.minName}
          onFocus={props.minOnFocus}
          id={props.minId}
          min={props.minMin}
          onChange={props.minOnChange}
          styles={props.minStyles}
          value={props.minValue}
          placeholder={props.minPlaceholder}
          hideLabel={props.hideMinLabel}
        />
      </Col>
      <Col className={props.rightColClass}>
        <InputBox
          label={props.label}
          hideLabel={"hide-label"}
          type={props.maxType}
          name={props.maxName}
          onFocus={props.maxOnFocus}
          id={props.maxId}
          min={props.maxMin}
          value={props?.maxValue}
          onChange={props.maxOnChange}
          styles={props.maxStyles}
          placeholder={props.maxPlaceholder}
        />
      </Col>
      {props?.checkboxLabel && (
        <Col lg="12 custom-padding">
          <CheckBox
            label={props.checkboxLabel}
            onChange={props.handleCheckboxChange}
            checked={props.checked}
            value={props.value}
            placeholder={props.checkboxLabel}
          />
        </Col>
      )}
    </>
  )
}

export default MinMaxInput
